import { Box, Typography, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { Button } from '../ui'

const errorStyle = { fontSize: '14px' }
interface Props {
  onDrop: (acceptedFiles: File[]) => void
  files: string[] | File[] | string
  errorMsg?: string
  label?: string
  disabled?: boolean
}

const getNameFromQuery = (name: string) => {
  if (!name) return ''
  const queryString = name.split('?')[1]
  const params = new URLSearchParams(queryString)
  return params.get('path')
}

export function UploadZone({
  onDrop,
  files,
  errorMsg,
  label,
  disabled,
}: Props) {
  const theme = useTheme()

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (uploadedFiles) => {
      onDrop(uploadedFiles)
      setUploadedFiles(uploadedFiles)
    },
    // TODO: add flag in case of need
    multiple: false,
  })

  const defaultFile = !files
    ? undefined
    : Array.isArray(files)
      ? files
      : [files as string]

  const [uploadedFiles, setUploadedFiles] = useState<string[] | File[]>(
    defaultFile
  )

  useEffect(() => {
    const defaultFile = !files
      ? undefined
      : Array.isArray(files)
        ? files
        : [files as string]

    const filtered = (defaultFile as unknown[])?.filter(
      (item) => !!item && item !== 'N/A'
    )
    setUploadedFiles(filtered as string[] | File[])
  }, [files])

  const [isDragging, setIsDragging] = useState(false)
  // const onDragEnter = () => setIsDragging(true)
  // const onDragLeave = () => setIsDragging(false)

  const removeFile = (e, fileName) => {
    e?.preventDefault()
    e?.stopPropagation()

    if (!uploadedFiles) return

    let files = (uploadedFiles as File[])?.filter((file) => {
      if (typeof file === 'string') {
        return file !== fileName
      }

      return file.name !== fileName
    })

    setUploadedFiles(files as unknown as string[] | File[])
    onDrop(files as File[])
  }

  return (
    <Box>
      <Box
        {...getRootProps()}
        style={{
          textAlign: 'center',
          padding: '20px',
          border: `2px dashed ${isDragging ? '#D13E43' : '#cccccc'}`,
          borderRadius: '10px',
          backgroundColor: isDragging ? '#FDECEC' : '#ffffff',
          transition: 'background-color 0.3s, border-color 0.3s',
        }}
      >
        <input {...getInputProps()} disabled={disabled} />
        <Button
          type="button"
          style={{
            borderRadius: '5px',
          }}
          disabled={disabled}
        >
          {label ?? 'Upload Files'}
        </Button>
        {uploadedFiles?.length > 0 ? (
          <div style={{ marginTop: '20px' }}>
            <h3>Uploaded Files:</h3>
            <ul style={{ listStyleType: 'none', padding: 0 }}>
              {uploadedFiles?.map((file, index) => (
                <li
                  key={index}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px',
                    padding: '10px',
                    border: '1px solid #cccccc',
                    borderRadius: '5px',
                  }}
                >
                  <span>{file?.name || getNameFromQuery(file)}</span>
                  <Button
                    size="small"
                    onClick={(e) => removeFile(e, file?.name || file)}
                    sx={{
                      height: 25,
                      borderRadius: '5px',
                      padding: '5px 10px',
                      cursor: 'pointer',
                    }}
                    disabled={disabled}
                  >
                    Remove
                  </Button>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </Box>{' '}
      {errorMsg && (
        <Typography sx={errorStyle} color={theme?.palette?.error?.main}>
          {errorMsg}
        </Typography>
      )}
    </Box>
  )
}
